<template>

<div class="cl-search_container">
  

  <div class="cl-search_view">

     <ul class="cl-search_tabs">
        <template v-for="tab of tabs">
         <li  class="tab-pane" :key="tab.id" v-bind:class="{'cl-tab cl-tabs_tab': true, 'active': (tab.id == activeTab.id) }">
           <a class="cl-tabs_tab" data-toggle="pill" href="javascript:void(0)" v-on:click="activateTab(tab)">{{ tab.title }}</a>
         </li>
      </template>
        
     
    </ul>
 

   <div class="cl-search_results"> 
    <div class="text-center" v-show="loading">
         <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
         </div>
        </div>
    <Pagination ref="pagin" v-model="currentPage" :items="items" :perPage="pageItems" @page-set="setPage"/>
     <div class="cl-tab_view" v-show="!loading"> 
       <div class="cl-search_main tab-content" >     
           <template v-for="tb of tabs">
              <div class="tab-pane"  v-bind:id="tb.id" v-bind:key="tb.id" v-bind:style='{"display": (tb.id == activeTab.id? "block" :"none")}'>
               <Transition name="swap" mode="out-in">
              <div class="search-list" v-if='isRecipeActive'>
                <RecipeResult class="sresult" v-for="(clresult,idx) in clresults.recipe.results" :item="clresult" :key="idx"  v-on="$listeners"/>
                <div v-show="clresults.recipe.results && clresults.recipe.results.length==0">No recipes found. Try adjusting you search term and filters and try again.</div> 
              </div>
              <div class="search-list" v-if='isIngredientActive'>
                <ResourceResult class="rresult" v-for="(clresult,idx) in clresults.ingredients.results" :item="clresult" :key="idx" v-on="$listeners"/>
                <div v-show="clresults.ingredients.results && clresults.ingredients.results.length==0">No ingredients found. Try adjusting you search term and filters and try again.</div> 
              </div>
              <div class="search-list" v-if='isOrgActive'>
                <OrgResult class="sresult" v-for="(clresult,idx) in clresults.organisations.results" :item="clresult" :key="idx" v-on="$listeners"/>
                <div v-show="clresults.organisations.results && clresults.organisations.results.length==0">No organisations found. Try adjusting you search term and filters and try again.</div> 
              </div>
              </Transition>
            </div>
            </template>
      </div>

      <div class="cl_search_filtersection">
       
         <div>
             <!--
            <div class="cl-search_filter">
              

              <CheckboxTabGroup @update="changeTabCount" :showTab="tabTrack" ref="checkedTabs"/>  
            </div>-->
         <h6 class="cl-search_section_header">Filter By</h6>
        <div v-show='isRecipeActive'>
          <template v-for="fil of filters.recipe" >
            
           <!-- <template v-if="fil.values.length<=3">
              <FilterCheckbox :filter="fil" :key="fil.label" v-on="$listeners"></FilterCheckbox></template>-->
         

            <template>
              <FilterMultiselect :filter="fil" :key="fil.label" v-on="$listeners" :facetSelection="facetSelection"></FilterMultiselect></template>
          </template>
        </div>
       
          <div v-show='isIngredientActive'>
          <template v-for="fil of filters.ingredients">
            
            <template>
              <FilterMultiselect :filter="fil" :key="fil.label" v-on="$listeners" :facetSelection="facetSelection"></FilterMultiselect></template>
             </template>
         </div>

          <div v-show='isOrgActive'>
          <template v-for="fil of filters.organisation" >
            
            <template>
              <FilterMultiselect :filter="fil" :key="fil.label" v-on="$listeners" :facetSelection="facetSelection"></FilterMultiselect></template>
          </template>
         </div>
         </div> 
      </div>

       
    </div>
   </div>
    
  </div>

  </div>
  </template>


<script>
import RecipeResult from './RecipeResult'
import ResourceResult from './ResourceResult'
import OrgResult from './OrgResult'
import CheckboxTabGroup from './CheckboxTabGroup'
import FilterCheckbox from './FilterCheckbox'
import FilterMultiselect from './FilterMultiselect'
import Pagination from './Pagination' 

export default {
  name: 'search-list',
  components: { RecipeResult, ResourceResult, OrgResult, CheckboxTabGroup, Pagination, FilterCheckbox, FilterMultiselect },
 
  data : function () {
            return {
                //form tags
              tabs:[ {
                    id: 1,
                    title: 'Recipes'
                    
                },
                {
                    id: 2,
                    title: 'Ingredients'
                    
                },
                {
                    id: 3,
                    title: 'Organisations'
                    
                }],
             inittabs:[],
             alltabs:[ {
                    id: 1,
                    title: 'Recipes'
                    
                },
                {
                    id: 2,
                    title: 'Ingredients'
                    
                },
                {
                    id: 3,
                    title: 'Organisations'
                    
                }],
           //  oTab:null,
             activeTab: {},
             clone:'',
             cpage: 1
            }
        },
   props: {
    pages: {
      type: Array,
      default: [1,1,1]
    },
    pageItems: {
       type: Number,
       default: 0   
    },
    loading:{
      type: Boolean,
      default () {
        return true
      }
     
    },
    clresults:{
      type: Object,
      default: {}
    },
     facetSelection:{
      type: Array,
      default: () => []
    },
    filters:{
      type: Object,
      default: {}
    },
    onlyTabResult:{
      type: String,
      default: null
    }
   },
   mounted: function(){
    this.inittabs=this.tabs.slice();
    if(this.onlyTabResult){
     this.tabs = this.tabs.filter(e => this.onlyTabResult==e.title).slice(0);
    }
    this.activeTab=this.tabs[0];

   },
   created: function() {
    this.inittabs=this.tabs.slice();

    if(this.onlyTabResult){
     this.tabs = this.tabs.filter(e => this.onlyTabResult==e.title).slice(0);
    
    }
   this.activeTab=this.tabs[0];
   
  },
 computed: {
       
      tabTrack:{
        get(){
          this.clone = JSON.parse(JSON.stringify(this.onlyTabResult));
          return this.clone;},
        set(val){
           this.clone=val;
           return this.clone;
        }
      },
       items(){
          let val=0;
          switch (this.activeTab.id){
           case 1:{ val = this.clresults.recipe.totalCount; break;}
           case 2: {val = this.clresults.ingredients.totalCount; break;}
           case 3: {val = this.clresults.organisations.totalCount; break;}
          }
          return val;
       },
       isRecipeActive(){
         return (this.activeTab? this.activeTab.id == 1 : false);
       },
       isIngredientActive(){
         return (this.activeTab? this.activeTab.id == 2 : false);
       },
       isOrgActive(){
         return (this.activeTab? this.activeTab.id == 3 : false);
       },
       currentPage:{
        get()
        {   return this.cpage=this.pages[this.activeTab.id-1];
        },
        set(val)
        {    this.pages[this.activeTab.id-1]=val;
             var pagetype=this.activeTab.id>1? 'Resource' : 'Recipe' ;
             if(this.activeTab.id==3){pagetype='Organisation'};
             var event = new CustomEvent("page-change", {
              detail: {
                 pagetype: pagetype,
                 page: val
              }
            });
         this.$emit('page-change',event);
            
        }
       },
       activeFilters(){
         if(this.activeTab.id==1){
            return this.filters.recipe;
          }
          else if(this.activeTab.id==3){
            return this.filters.organisation;
          }
          else if(this.activeTab.id==2){
            return this.filters.ingredients;
          }
       }
       
  },
  methods:{
      refresh: function() {
         var self=this;
          if(this.$parent.onlyTab){

            this.tabs = this.tabs.filter(e => self.$parent.onlyTab===e.title).slice(0);
           /* this.$refs.checkedTabs.coptions.forEach(function(element) {
              if(element.name===self.$parent.onlyTab)
                element.selected=true;
              else
                element.selected=false;
            });*/
          }
          else{this.tabs=this.inittabs.slice();
         // this.$refs.checkedTabs.coptions.forEach(function(element) {element.selected=true;});
         }
          
         
      },
      resetTabs:function(){
        this.tabs=this.alltabs.slice();
        this.inittabs=this.alltabs.slice();
       // this.$refs.checkedTabs.coptions.forEach(function(element) {element.selected=true;});
        this.activeTab=this.tabs[0];
        
      
      },
       changeTabCount: function(cltypes){
          this.tabs = this.alltabs.filter(e => cltypes.includes(e.title)).slice(0);
          this.activeTab=this.tabs[0];
          
       },
       activateTab: function(tab) {
          this.activeTab = tab;
           
       },
       setPage: function(val){
          this.currentPage=val;
       }
  }
}
</script>
 
 
<style scoped>
  .search-list {
    outline: none;
    margin-top:10px;
  }
 
  .sresult {
    padding: 7px 12px 12px 12px;
    border-radius: 4px;
    margin-bottom: 10px;
    background-color: white;

  }
 
  .rresult {
    padding: 7px 12px 12px 12px;
    border-radius: 4px;
    margin-bottom: 5px;
    background-color: white;

  } 

  .divisiible{
    display:block;
    height:200px;
  }


 .footer {
    padding: 15px;
    color: #777;
    border-top: 1px solid #e5e5e5;
    font-size: 13px;
    padding: 12px 28px 12px 28px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
  }

  @media only screen and (min-width: 600px) {
    .sresult {
      width: 100%;
    }
    .rresult {
      width: 100%;
    }
  }

   /* VUE TRANSITION */
  .swap-enter-active, .swap-leave-active {
    transition: all .25s ease-in-out;
  }
  .swap-enter, .swap-leave-active {
    opacity: 0;
  }
  .swap-enter {
    transform: translateX(75px);
  }
  .swap-leave-to {
    transform: translateX(-75px);
  }


  @keyframes spinner-border {
      to { transform: rotate(360deg); }
    } 
    .spinner-border{
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: .25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border .75s linear infinite;
        animation: spinner-border .75s linear infinite;
    }
    .spinner-border-sm{
        
        border-width: .2em;
    }

  
    .cl-search_container{
        position: relative;
        flex: auto;
        overflow: hidden;
        height: 100%;
        
    }


    .cl-search_view{
        background-color: #eeeeee59;
        height: 100%;
        flex-direction: column;
        display:flex;
    }

    .cl-search_tabs{
        flex: 0 0 auto;
        padding: 0 48px 0 8px;
        background-color: white;
    }

    .cl-tab_view{
        display: flex;
    }

    .cl-tab{
        height: 52px;
        padding: 16px 4px 16px 4px;
        border-radius: 0;
        font-size: 13px;
        line-height: 1.46668;
        font-weight: 400;
        font-weight: 700;
        text-align: center;
    }

    .cl-tabs_tab {
        font-size: 13px;
        line-height: 1.38463;
        font-weight: 400;
        background: none;
        border: 0;
        box-shadow: inset 0 -2px 0 0 transparent;
        color: rgba(var(--sk_foreground_max_solid,97,96,97),1);
        cursor: pointer;
        display: inline-block;
        font-weight: 700;
        padding: 12px 8px;
        text-align: center;
        transition: box-shadow .125s ease-out;
    }

    .cl-tabs_tab:not(:last-child) {
        margin-right: 12px;
    }

    .cl-search_tabs > li.active > a,
    .cl-search_tabs > li.active > a:hover,
    .cl-search_tabs > li.active > a:focus {
        border-radius: 0;
        box-shadow: inset 0 -2px 0 0 #337ab7;
        text-decoration: none;
        color: inherit;
        background-color: transparent !important;
        font-size: larger;
    }

    .cl-tabs_tab > a:hover {
        color: grey;
        text-decoration: none;
        background-color: transparent !important;
    }

    .cl-search_results{
        flex: 1 1 auto;
        padding: 10px 20px 0 20px;
        overflow-y: scroll;
        max-height: 60vh;
        padding-bottom: 5em;
    }

    .cl-tabview{
        display: flex;
    }

    .cl-search_main {
        font-size: 15px;
        line-height: 1.46668;
        font-weight: 400;
        flex: 1 1 auto;
        padding-right: 24px;
        max-width: 67%;
        word-break: break-word;
        overflow-wrap: break-word;
    }


    .cl-search_section_header {
        font-size: 16px;
        color: #1D809F;
        font-weight: bold;
        display: inline;
    }


    .cl_search_filtersection {
        width: 33%;
        flex: 0 0 33%;
        position: relative;
        padding-bottom: 32px;
        margin-bottom:150px;
    }


</style>



// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/SearchList.vue